/**
 * Created by markusr on 10.6.2015.
 * This is a main VM for all page component VMs
 * Lots of functions and properties from training should be moved here
 */
define('page-component',['knockout', 'component-accordion', 'component-diploma', 'component-extra-info', 'component-flip-cards', 'component-media', 'component-slide-show',  'component-statistics', 'component-super-button', 'component-tabs'], function(ko, Accordion, Diploma, ExtraInfo, FlipCards, Media, SlideShow, Statistics, SuperButton, Tabs) {

    return function(parentVM, dataContext) {
        var self = this;

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        self.accordion = new Accordion(parentVM, dataContext);

        self.diploma = new Diploma(parentVM, dataContext);

        self.extraInfo = new ExtraInfo(parentVM, dataContext);

        self.flipCards = new FlipCards(parentVM, dataContext);

        self.media = new Media(parentVM, dataContext);

        self.slideShow = new SlideShow(parentVM, dataContext);

        self.statistics = new Statistics(parentVM, dataContext);

        self.superButton = new SuperButton(parentVM, dataContext);

        self.tabs = new Tabs(parentVM, dataContext);

    }
});

